import React, { useMemo } from 'react'

import Chart from './DriverChart.d3'
import ChartWrapper from '../ChartWrapper'

const DriverChart = ({
  data,
  lineKeys,
  inModal,
  chartId,
  relations,
  isPoD,
  setSelection = () => {},
}) => {
  const updateProps = useMemo(
    () => ({
      data,
      lineKeys,
    }),
    [data, lineKeys],
  )

  return (
    <ChartWrapper
      Chart={Chart}
      initProps={{
        data,
        relations,
        setSelection,
        lineKeys,
        inModal,
        chartId,
        isPoD
      }}
      updateProps={updateProps}
      margin={{ BOTTOM: 20, LEFT: 50, TOP: 40, RIGHT: 40 }}
    />
  )
}

export default DriverChart
